<template>
  <div class="card shadow" :class="type === 'dark' ? 'bg-default' : ''">
    <div
      class="card-header border-0"
      :class="type === 'dark' ? 'bg-transparent' : ''"
    >
      <div class="row align-items-center">
        <div id="errorNotification" class="col-md-12">
          <base-alert v-if="errorMessage != null" type="danger">
            <span class="alert-inner--text"> {{ errorMessage }}</span>
            <button
              type="button"
              class="close"
              aria-label="Close"
              @click="removeMessage('error')"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </base-alert>
          <base-alert v-if="successMessage != null" type="success">
            <span class="alert-inner--text"> {{ successMessage }}</span>
            <button
              type="button"
              class="close"
              aria-label="Close"
              @click="removeMessage('success')"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </base-alert>
        </div>
        <div class="col-md-3">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white'  : ''">
            {{  _.startCase(currentProfile)  }}
          </h3>
        </div>
        <div class="col-md-9 text-right">
          <base-dropdown class="nav-link pr-0 float-right" position="right">
            <div class="media align-items-center" slot="title">
              <i class="fa fa-ellipsis-v float-right ml-2 btn-sm"></i>
            </div>
            <template>
              <div class="dropdown-header noti-title">
                <h6 class="text-overflow m-0">ACTIONS</h6>
              </div>
              <div v-if="accessRights.includes('T') && currentProfile !== 'sites' && currentProfile !== 'companies'" class="dropdown-item"
                @click.prevent="showActionDrawer('print_list')">
                <i class="fa fa-print"></i>
                <span>Print</span>
              </div>
              <div v-if="serverType == 'ho' && accessRights.includes('I')" class="dropdown-item"
                @click.prevent="showActionDrawer('import_list')">
                <i class="fa fa-upload"></i>
                <span>Import</span>
              </div>
              <div class="dropdown-item" @click.prevent="showActionDrawer('export_list')">
                <i class="fa fa-download"></i>
                <span>Export</span>
              </div>
              <div class="dropdown-item" @click.prevent="showActionDrawer('customize_list')">
                <i class="fa fa-list-ul"></i>
                <span>Customize List</span>
              </div>
            </template>
          </base-dropdown>
          <div v-if="serverType == 'ho'">
            <div v-if="checkedItems.length == 0 && accessRights.includes('A')">
              <base-button v-if="currentProfile == 'user_groups'" class="float-right ml-1" type="primary" size="sm"
                @click.prevent="showModal(0)" v-b-modal.user-group-modal>+ Add New
                {{ _.startCase(_.singularize(currentProfile)) }}</base-button>
              <base-button v-else class="float-right ml-1" type="primary" size="sm" @click.prevent="showDrawer(0)">+ Add
                New {{ _.startCase(_.singularize(currentProfile)) }}</base-button>
            </div>

            <div v-else-if="checkedItems.length > 0 && accessRights.includes('W')">
              <base-button v-if="this.$parent.filterStatus != 'A'" class="float-right ml-1" type="default" size="sm"
                @click.prevent="massupdate('status', 'A')">Activate</base-button>
              <base-button v-if="this.$parent.filterStatus != 'I'" class="float-right ml-1" type="default" size="sm"
                @click.prevent="massupdate('status', 'I')">Deactivate</base-button>
              <div class="ml-1"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a-drawer title="" :width="480" placement="right" @close="onClose" :visible="drawerVisible">
      <div v-if="profileAction == 'customize_list'">
        <h6 class="heading-small text-muted mb-4">Customize Fields</h6>
        <small>Check the fields that you want to see on the list. Drag the fields to
          specify position.</small>
        <br /><br />

        <div class="list-group list-group-item">
          <div class="row">
            <div class="col-md-6"><b>AVAILABLE FIELDS</b></div>
            <div class="col-md-6">
              <a-checkbox class="float-right" @change="onCheckAllField" :checked="
                this.checkedFields.length == this.availableFields.length
              " />
            </div>
          </div>
        </div>

        <draggable :key="draggableKey" :list="availableFields" class="list-group" @start="dragging = true"
          @end="dragging = false">
          <div class="list-group-item draggable"
            :style="index == availableFields.length - 1 ? 'margin-bottom: 50px;' : ''"
            v-for="(element, index) in availableFields" :key="element">
            <div class="row">
              <!-- This _.startCase() will convert any casing into Start Case -->
              <div class="col-md-6">
                {{ _.startCase(element) }}
              </div>
              <div class="col-md-6">
                <a-checkbox class="float-right" @change="onCheckField(element)"
                  :checked="checkedFields.includes(element)" />
              </div>
            </div>
          </div>
        </draggable>

        <div class="float-right" style="position: absolute; bottom: 20px; right: 20px">
          <button class="btn btn-primary float-right" @click.prevent="updateTableList">
            Update List
          </button>
        </div>
      </div>

      <div v-if="profileAction == 'export_list'">
        <h6 class="heading-small text-muted mb-4">Export Options</h6>

        <base-alert v-if="errors.length" type="danger">
          <b>You have the following error(s):</b>
          <ul>
            <li v-for="error in errors" :key="error">{{ error }}</li>
          </ul>
        </base-alert>

        <div>
          <a-radio-group v-model="exportSelection">
            <a-radio :style="radioStyle" :value="0">Export All</a-radio>
            <a-radio :style="radioStyle" :value="1">Export Current Page</a-radio>
            <a-radio :style="radioStyle" :value="2">Export Selected</a-radio>
            <a-radio v-if="currentProfile != 'users' && currentProfile != 'user_groups'" :style="radioStyle" :value="3">
              Export Filtered</a-radio>
          </a-radio-group>
        </div>

        <div
          style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
          <button type="button" class="btn btn-primary float-right" @click.prevent="download">Export</button>
        </div>
      </div>

      <div v-if="profileAction == 'print_list'">
        <h6 class="heading-small text-muted mb-4">Print Options</h6>
      </div>

      <div v-if="profileAction == 'import_list'">
        <import-profile @closeDrawer="closeDrawer"></import-profile>
      </div>
    </a-drawer>

    <a-drawer title="" :width="480" placement="right" @close="onClose" :visible="visible">
      <div>
        <company-form v-if="currentProfile == 'companies'" @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage"
          :key="componentKey" :viewMode="viewMode"></company-form>
        <site-form v-if="currentProfile == 'sites'" @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage"
          :key="componentKey" :viewMode="viewMode" :locationOptions="locationOptions"></site-form>
        <territory-form v-if="currentProfile == 'territories'" @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage"
          :key="componentKey" :viewMode="viewMode"></territory-form>
        <user-form v-if="currentProfile == 'users'" @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage"
          :key="componentKey" :viewMode="viewMode" :locationOptions="locationOptions"></user-form>
        <sublocation-form v-if="currentProfile == 'sublocations'" @closeDrawer="closeDrawer"
          v-on:refreshPage="refreshPage" :key="componentKey" :viewMode="viewMode"></sublocation-form>
      </div>
    </a-drawer>
    <a-drawer title="" :width="800" placement="right" @close="onClose" :visible="historyVisible">
      <div>
        <h6 v-if="currentProfile == 'users'" class="heading-small text-muted mb-4 text-truncate">User Action History</h6>
        <h6 v-if="currentProfile == 'user_groups'" class="heading-small text-muted mb-4 text-truncate">User Group Action
          History</h6>
        <a-table v-if="currentProfile == 'user_groups'" :columns="historyColumns" :dataSource="historyData"
          size="small" />
        <a-table v-if="currentProfile == 'users'" :columns="historyColumns2" :dataSource="historyData" size="small" />
      </div>
    </a-drawer>

    <user-group-modal v-on:refreshPage="refreshPage" :key="modalKey" :viewMode="viewMode" :visible="userGroupVisible">
    </user-group-modal>

    <div class="table-responsive">
      <!-- {{this.accessRights}} -->
      <a-spin :spinning="loading">
        <vuetable ref="vuetable" :api-url="apiURL" :http-options="httpOptions" :fields="fields" :sort-order="sortOrder"
          :show-sort-icons="true" :per-page="10" :css="css.table" no-data-template="Empty" pagination-path=""
          data-path="data" @vuetable:checkbox-toggled-all="log" @vuetable:checkbox-toggled="log"
          @vuetable:load-error="onLoadError" @vuetable:pagination-data="onPaginationData">
          <template slot="actions" slot-scope="props">
            <center>
              <div v-if="serverType == 'ho' && currentProfile == 'users'" class="table-button-container">
                <button id="history" class="btn btn-primary btn-sm"
                  @click.prevent="showHistoryDrawer(props.rowData.id)">History</button>
                <button v-if="accessRights.includes('V')" id="view" class="btn btn-success btn-sm"
                  @click.prevent="showDrawer(props.rowData.id)">View</button>
                <button v-if="accessRights.includes('W') && props.rowData.is_system == false"
                  class="btn btn-warning btn-sm" @click.prevent="showDrawer(props.rowData.id)">Edit</button>
                <button v-if="accessRights.includes('D') && props.rowData.is_system == false"
                  class="btn btn-danger btn-sm text-white" @click.prevent="checkBindedItems(props.rowData)">Delete</button>
              </div>
              <div v-else-if="serverType == 'ho'" class="table-button-container">
                <button v-if="currentProfile == 'user_groups'" id="history" class="btn btn-primary btn-sm"
                  @click.prevent="showHistoryDrawer(props.rowData.id)">History</button>
                <button id="view" v-if="currentProfile == 'user_groups' && accessRights.includes('V')"
                  class="btn btn-success btn-sm" @click.prevent="showModal(props.rowData.id)"
                  v-b-modal.user-group-modal>View</button>
                <button v-else-if="accessRights.includes('V') && currentProfile != 'user_groups'"
                  class="btn btn-success btn-sm" @click.prevent="showDrawer(props.rowData.id)" id="view">View</button>
                <button v-if="currentProfile == 'user_groups' && accessRights.includes('W')"
                  class="btn btn-warning btn-sm" @click.prevent="showModal(props.rowData.id)"
                  v-b-modal.user-group-modal>Edit</button>
                <button v-else-if="accessRights.includes('W') && currentProfile != 'user_groups'"
                  class="btn btn-warning btn-sm" @click.prevent="showDrawer(props.rowData.id)">Edit</button>
                <button v-if="accessRights.includes('D')" class="btn btn-danger btn-sm text-white"
                  @click.prevent="checkBindedItems(props.rowData)">Delete</button>
              </div>
              <div v-else class="table-button-container">
                <button v-if="currentProfile == 'user_groups' && accessRights.includes('V')"
                  class="btn btn-success btn-sm" @click.prevent="showModal(props.rowData.id)" id="view"
                  v-b-modal.user-group-modal>View</button>
                <button v-else-if="accessRights.includes('V') && currentProfile != 'user_groups'"
                  class="btn btn-success btn-sm" @click.prevent="showDrawer(props.rowData.id)"
                  id="view">View</button>&nbsp;&nbsp;
              </div>
            </center>
          </template>
        </vuetable>
      </a-spin>
      <a-modal 
                :visible="deleteModalVisible" 
                :title="bindedItems !== 0? 'Cannot delete attribute' : 'You are about to delete this record?'" 
                :wrapClassName="bindedItems !== 0 ? 'advanced-profile-delete-modal-warning' : 'advanced-profile-delete-modal-danger'"
                :okButtonProps="bindedItems !== 0 && { style: { display: 'none'} }"
                :cancelButtonProps="{ props: { type: 'default' }, style: { color: '#6c757d', borderColor: '#6c757d' } }"
                cancelText="Close"
                okText="Proceed"
                @ok="deleteAttribute(currentRowDataId)" 
                @cancel="closeDeleteModal"
                :closable="false"
                >
                <p v-if="bindedItems!== 0">
                  There are {{ bindedItems }} item/s currently using this attribute. <br>
                  Name: <strong>{{ currentRowDataName }}</strong>
                </p>
                <p v-else>
                  You are about to delete <strong>{{ currentRowDataName }}</strong>. Would you like to continue?
                </p>
              </a-modal>
    </div>

    <div class="card-footer d-flex justify-content-end" :class="type === 'dark' ? 'bg-transparent' : ''">
      <div class="pagination ui basic segment grid">
        <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage" :css="css.pagination">
        </vuetable-pagination>
      </div>
    </div>

  </div>
</template>

<script>
import axios from "axios";
import { mapState, mapActions } from "vuex";
import CompanyForm from "../Advanced Profiles/CompanyForm.vue";
import SiteForm from "../Advanced Profiles/SiteForm.vue";
import TerritoryForm from "../Advanced Profiles/TerritoryForm.vue";
import UserGroupModal from "../Advanced Profiles/UserGroupModal.vue";
import UserForm from "../Advanced Profiles/UserForm.vue";
import SublocationForm from "../Advanced Profiles/SublocationForm.vue";

import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import secureStorage from "../../controllers/secureStorage";
import HTTPRequest from "../../controllers/httpRequest.js";
import draggable from "vuedraggable";

import { formatStatus } from "../../utilities.js"

import ImportProfile from '../ImportProfile';
var component_x;

import moment from "moment";

export default {
  name: "profiles-table",
  props: {
    type: {
      type: String
    },
    title: String
  },
  components: {
    Vuetable,
    VuetablePagination,
    CompanyForm,
    SiteForm,
    TerritoryForm,
    UserGroupModal,
    UserForm,
    SublocationForm,
    ImportProfile,
    draggable
  },
  computed: {
    ...mapState([
      "currentProfile",
      "currentApiURL",
      "endPoint",
      "profileId",
      "parameters",
      "serverType",
    ]),
  },
  data() {
    return {
      initLoad: 0,
      loading: false,
      locationOptions: [],
      userGroupVisible: false,
      viewMode: false,
      accessRights: [],
      errors: [],
      filterStatus: "",
      exportSelection: 0,
      profileAction: "",
      checkedFields: [],
      checkedItems: [],
      availableFields: [],
      errorMessage: null,
      successMessage: null,
      componentKey: 0,
      modalKey: 0,
      drawerVisible: false,
      visible: false,
      deleteModalVisible: false,
      historyVisible: false,
      historyData: [],
      bindedItems: 0,
      currentRowDataId: null,
      currentRowDataName: "",
      apiURL: "",
      historyColumns: [
        {
          title: "Action",
          dataIndex: "action",
        },
        {
          title: "Action By",
          dataIndex: "action_by",
        },
        {
          title: "Action At",
          dataIndex: "action_at",
          customRender: (value) => (
            <div> {moment(value).format("YYYY-MM-DD HH:mm:ss A")}</div>
          ),
        },
      ],
      historyColumns2: [
        {
          title: "Action",
          dataIndex: "action",
        },
        {
          title: "Action By",
          dataIndex: "action_by",
        },
        {
          title: "Action At",
          dataIndex: "action_at",
        },
      ],
      // fields: ['__checkbox', "id", "code", "name", "status", '__slot:actions'],
      fields: [
        "__checkbox",
        {name: "id", title: "id"},
        {name: "code", title: "code"},
        {name: "name", title: "name"},
        {name: "status", title: "status"},
        "__slot:actions"
      ],
      sortOrder: [
        {
          field: "name",
          direction: "asc",
        },
      ],
      httpOptions: {
        headers: {
          Authorization: "Bearer " + secureStorage.getItem("accessToken"), 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") 
        },
      },
      css: {
        table: {
          tableClass:
            "table table-sm table-striped table-bordered table-hovered",
          loadingClass: "loading",
        },
        pagination: {
          infoClass: "pull-right",
          wrapperClass: "vuetable-pagination pull-right",
          activeClass: "btn-primary btn-sm",
          disabledClass: "disabled",
          pageClass: "btn btn-border",
          linkClass: "btn btn-border",
          icons: {
            first: "",
            prev: "",
            next: "",
            last: "",
          },
        },
      },
      radioStyle: {
        display: "block",
        height: "30px",
        lineHeight: "30px",
      },
      draggableKey: 0
    };
  },
  watch: {
    currentApiURL: function() {
      this.$refs.vuetable.resetData();
      this.apiURL = this.currentApiURL;
    },
    parameters: function () {
      this.apiURL = this.currentApiURL
      this.apiURL = this.apiURL + this.parameters
      this.$refs.vuetable.selectedTo = []
      this.checkedItems = []
    },
    // checkedFields: function () {
    //   if (!this.checkedFields.length) {
    //     this.$notification['warning']({
    //       message: 'Customized columns cannot be empty',
    //       description: 'Columns reset to default.',
    //       placement: 'bottomRight'
    //     })
    //     if(this.currentProfile == "users"){
    //       this.checkedFields = ["user_name","name", "status"]
    //       this.fields = [
    //                 "__checkbox",
    //                 {name: "id", title: "id"},
    //                 {name: "user_name", title: "username"},
    //                 {name: "name", title: "name"},
    //                 {name: "status", title: "status"},
    //                 "__slot:actions"
    //               ]
    //     }else{
    //       this.checkedFields = ["code", "name", "status"]
    //       this.fields = [
    //                 "__checkbox",
    //                 {name: "id", title: "id"},
    //                 {name: "code", title: "code"},
    //                 {name: "name", title: "name"},
    //                 {name: "status", title: "status"},
    //                 "__slot:actions"
    //               ]
    //     }
    //     this.reinitializeFields()
    //   }
    // },
    currentProfile: function () {
      this.initializeTable()
    },
    checkedFields: function () {
      if (!this.checkedFields.length) {
        this.$notification['warning']({
          message: 'Customized columns cannot be empty',
          description: 'Columns reset to default.',
          placement: 'bottomRight'
        })
        if(this.currentProfile == 'users'){
          this.checkedFields = ["id", "user_name", "name", "status"]
          this.fields = ["__checkbox", { "name": "id", "title": "id" },  { "name": "user_name", "title": "user name" }, { "name": "name", "title": "name" }, { name: "status", callback: (value) => formatStatus(value)}, "__slot:actions"]
        }else{
          this.checkedFields = ["id", "code", "name", "status"]
          this.fields = ["__checkbox", { "name": "id", "title": "id" },  { "name": "code", "title": "code" }, { "name": "name", "title": "name" }, { name: "status", callback: (value) => formatStatus(value)}, "__slot:actions"] 
        }
      }
    },
  },
  methods: {
    ...mapActions(["updateProfileId"]),
    closeDrawer() {
      this.onClose();
    },
    refreshPage() {
      this.onClose();
      this.$refs.vuetable.refresh();
      this.successMessage = "Successful Operation";
      this.errorMessage = null;
    },
    showModal(id) {
      if (event.target.id == "view") {
        this.viewMode = true;
      } else {
        this.viewMode = false;
      }
      this.modalKey++;
      this.userGroupVisible = true;
      this.updateProfileId(id);
    },
    async showHistoryDrawer(id) {
      if (this.currentProfile == "users") {
        if (event.target.id == "history") {
          var userHistory = await HTTPRequest.getRequest(this.endPoint + "user_action_histories/" + id + "?field_name=profile_id", null);
          this.historyData = userHistory
          console.log(this.historyData)
        }
      } else if (this.currentProfile == "user_groups") {
        if (event.target.id == "history") {
          var userGroupHistory = await HTTPRequest.getRequest(this.endPoint + "user_group_action_histories/" + id + "?field_name=group_id", null);
          this.historyData = userGroupHistory
          console.log(this.historyData)
        }
      }
      this.historyVisible = true
    },
    showDrawer(id) {
      if (event.target.id == "view") {
        this.viewMode = true;
      } else {
        this.viewMode = false;
      }
      this.componentKey++;
      this.updateProfileId(id);
      this.visible = true;
    },
    async showActionDrawer(action) {
      if (action == "customize_list") {
        var response = await HTTPRequest.getRequest(
          this.endPoint + this.currentProfile + "/get_viewable_fields",
          null
        );
        
        let unsortedFields = response["fields"];
        let sortedFields = this.checkedFields.slice();

        unsortedFields.forEach(fieldName => {
          if (!this.checkedFields.includes(fieldName))
            sortedFields.push(fieldName)
        });

        this.availableFields = sortedFields;

      }
      this.profileAction = action;
      this.drawerVisible = true;
    },
    onClose() {
      this.errors = [];
      this.drawerVisible = false;
      this.historyVisible = false;
      this.visible = false;
      this.componentKey++;
    },
    log() {
      this.checkedItems = this.$refs.vuetable.selectedTo;
    },
    onCheckField(fieldName) {
      if (this.checkedFields.includes(fieldName)) {
        var indexValue = this.fields.findIndex(object => {
                                  return object.name == fieldName;
                                });
        if (indexValue > -1) this.fields.splice(indexValue, 1)
        var indexValue2 = this.checkedFields.indexOf(fieldName)
        if (indexValue2 > -1) this.checkedFields.splice(indexValue2, 1)
        console.log("delete")
      } else {
        let filterColumn = ""
        if(fieldName == "user_name"){
          filterColumn = fieldName.replace(/_/g, "")
        }else{
          filterColumn = fieldName.replace(/_/g, " ")
        }
        if (!this.fields.includes(fieldName)) {
          this.fields.pop()
          this.fields.push({name: fieldName, title: filterColumn })
          this.fields.push("__slot:actions")
        }
        console.log("add")
        this.checkedFields.push(fieldName)
      }

      let storeName = this.currentProfile + "AdvancedProfileCheckedFields"
      localStorage.setItem(storeName, JSON.stringify(this.checkedFields))
      this.reinitializeFields()
    },
    onCheckAllField() {
      if (this.checkedFields.length == this.availableFields.length) {
        console.log("Empty")
        this.checkedFields = []
        // this.fields = [
        //                 "__checkbox",
        //                 {name: "id", title: "id"},
        //                 {name: "name", title: "name"},
        //                 "__slot:actions"
        //               ]
      } else {
        console.log("Copy")
        let insertField = []
        this.checkedFields = this.availableFields.slice()
        this.fields = ['__checkbox']
        this.checkedFields.forEach((c)=>{
          let filterColumn = ""
          if(c == "user_name"){
            filterColumn = c.replace(/_/g, "")
          }else{
            filterColumn = c.replace(/_/g, " ")
          }
          this.fields.push({name: c, title: filterColumn})
        })
        this.fields.push("__slot:actions")
      }
      // console.log(this.fields)
      let storeName = this.currentProfile + "AdvancedProfileCheckedFields"
      localStorage.setItem(storeName, JSON.stringify(this.checkedFields))
      this.reinitializeFields()
    },
    reinitializeFields() {
      this.$nextTick(() => {
        this.$refs.vuetable.normalizeFields();
      });
    },
    async create_action_history(action, id) {
      if (this.currentProfile == "users") {
        var actionHistoryPayload = {
          action: action,
          action_at: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
          action_by: secureStorage.getItem("userName"),
          profile_id: id,
          status: "A",
        };
        await HTTPRequest.postRequest(
          this.endPoint + "user_action_histories/",
          null,
          actionHistoryPayload
        );
      } else if (this.currentProfile == "user_groups") {
        var actionHistoryPayload = {
          action: action,
          action_at: moment(new Date()),
          action_by: secureStorage.getItem("userName"),
          group_id: id,
          status: "A",
        };
        await HTTPRequest.postRequest(
          this.endPoint + "user_group_action_histories/",
          null,
          actionHistoryPayload
        );
      }
    },
    async massupdate(field_name, value) {
      var field_update = {};
      var now = new Date();
      field_update[field_name] = value;
      field_update["updated_at"] = moment(now)
        .utcOffset("+1600")
        .format("YYYY-MM-DD HH:mm:ss");
      var payload = { ids: this.checkedItems, field_update: field_update };
      var response = await HTTPRequest.postRequest(
        this.endPoint + this.currentProfile + "/mass_update",
        null,
        payload
      );
      console.log(this.$refs.vuetable.selectedTo);
      if (response["message"] == "Ok") {
        this.successMessage = "Update successful!";
        for (let i = 0; i < this.$refs.vuetable.selectedTo.length; i++) {
          this.create_action_history(
            "Update",
            this.$refs.vuetable.selectedTo[i]
          );
        }
        this.$refs.vuetable.refresh();
        this.checkedItems = [];
        this.$refs.vuetable.selectedTo = [];
      } else {
        this.successMessage = "Update failed!";
        // alert("Error processing")
      }
    },
    async onPaginationData(paginationData) {
      // await axios({
      //   method: 'PUT',
      //   url: this.endPoint.split("/api")[0] + "/api/v2/backend_sessions/" + secureStorage.getItem("sessionId") + "/update_timestamp",
      //   headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") },
      // })
      this.$refs.pagination.setPaginationData(paginationData);
    },
    async onLoadError(error) {
      // request for new token or reauthenticate
      if (error.response.status == 401) {
        var auth_response = await HTTPRequest.authenticate(
          component_x.endPoint
        );
        if (auth_response["status"] == "Ok") {
          this.$router.go();
        } else {
          alert("Cannot get access token. Please login again.");
          this.$router.push("/");
        }
      } else {
        if (error.response.data.error == "Session expired") {
          alert("Session is already expired. Please login again.");
          document.getElementById("logoutButton").click();
        }  else if(error.response.data.error == "Invalid IP for Access Token"){
          alert("Invalid Access Token. Please login again.")
          document.getElementById("logoutButton").click()
        }
      }
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    async checkBindedItems(rowData) {
      this.currentRowDataId = rowData.id
      this.currentRowDataName = rowData.name || ""
      axios({
        method: "get",
        url: this.endPoint + this.currentProfile + "/check_binded_items?id=" + rowData.id,
        headers: {
          Authorization: "Bearer " + secureStorage.getItem("accessToken"),
          "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") 
        },
      }).then(function(resp) {
        component_x.bindedItems = resp.data.length;
        component_x.deleteModalVisible = true;
      })
        .catch(function() {
          alert("Invalid Credentials");
        });
    },
    deleteAttribute(id) {
      this.deleteRow(id)
      this.closeDeleteModal()
    },
    closeDeleteModal() {
      this.bindedItems = 0
      this.currentRowDataId = null
      this.currentRowDataName = ""
      this.deleteModalVisible = false
    },
    deleteRow(id) {
      axios({
        method: "delete",
        url: this.endPoint + this.currentProfile + "/" + id,
        headers: {
          Authorization: "Bearer " + secureStorage.getItem("accessToken"),
          "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") 
        },
      })
        .then(function() {
          component_x.successMessage = "Successfully deleted record";
          component_x.$refs.vuetable.refresh();
        })
        .catch(function() {
          alert("Invalid Credentials");
        });
    },
    download() {
      // Must update other Profile Tables download function to be aligned
      var payload = {};
      var additional_parameters = "";
      var baseUrl = this.currentApiURL + "/download?file_type=csv";
      if (this.exportSelection == "0") {
        // All
        payload["type"] = "all";
      } else if (this.exportSelection == "1") {
        // Current Page
        var ids = this.$refs.vuetable.tableData.map(({ id }) => id);
        payload["type"] = "current_page";
        if (ids == 0) {
          this.errors.push("No Record(s)");
          return;
        } else {
          payload["ids"] = ids;
        }
      } else if (this.exportSelection == "2") {
        // Selected
        payload["type"] = "selected";
        if (this.checkedItems == 0) {
          this.errors.push("No Selected Record(s)");
          return;
        } else {
          payload["ids"] = this.checkedItems;
        }
      } else {
        // Filtered
        payload["type"] = "filtered";
        additional_parameters = this.parameters;
      }

      var exportFields = this.fields;
      var cbIndex = this.fields.indexOf("__checkbox");
      if (cbIndex > -1) exportFields.splice(cbIndex, 1);
      var actionIndex = this.fields.indexOf("__slot:actions");
      if (actionIndex > -1) exportFields.splice(actionIndex, 1);

      payload["fields"] = exportFields;
      additional_parameters = additional_parameters.replace("?", "&");

      axios({
        url: baseUrl + additional_parameters,
        method: "POST",
        responseType: "blob", // important
        headers: {
          Authorization: "Bearer " + secureStorage.getItem("accessToken"),
          "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") 
        },
        data: payload,
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "file.csv");
        document.body.appendChild(link);
        link.click();
        this.onClose();
        this.filterStatus = null;
        this.successMessage = "Download successful";
      });
    },
    displayMessage(message) {
      if (message["error"] != undefined) {
        this.onClose();
        this.errorMessage = message["error"];
        this.successMessage = null;
      }
    },
    removeMessage(type) {
      if (type == "error") this.errorMessage = null;
      else this.successMessage = null;
    },
    updateTableList() {
      var reference_array = this.availableFields;
      var array = this.checkedFields;
      if (array.length) {
        array.sort(function (a, b) {
          return reference_array.indexOf(a) - reference_array.indexOf(b);
        });
        this.checkedFields = array;
      } else {
        this.checkedFields = ["id", "code", "name", "status"];
        this.$notification['warning']({
          message: 'Customized columns cannot be empty',
          description: 'Columns reset to default.'
        })
      }

      let localStoreName = this.currentProfile + "AdvancedProfileCheckedFields";
      localStorage.setItem(localStoreName, JSON.stringify(this.checkedFields));

      this.fields = this.checkedFields.map(column => {
        if (column === "status") {
          return {
            name: "status",
            callback: (value) => formatStatus(value)
          }
        } else  {
          return {
            name: column,
            title: column.replace(/_/g, " ")
          }
        }
      })
      this.fields.push("__slot:actions");
      this.fields.unshift("__checkbox")

      this.reinitializeFields();
      this.onClose();
    }
  },
  beforeMount: async function () {
    let localStoreName = this.currentProfile + "AdvancedProfileCheckedFields"
    const AdvancedProfileCheckedFields = localStorage.getItem(localStoreName)
    if (AdvancedProfileCheckedFields != undefined && AdvancedProfileCheckedFields != null && AdvancedProfileCheckedFields != "[]") {
      this.checkedFields = JSON.parse(AdvancedProfileCheckedFields)
      // this.fields = JSON.parse(AdvancedProfileCheckedFields)
      // this.fields.unshift("id")
      // this.fields.unshift("__checkbox")
      this.fields = this.checkedFields.map(column => {
        if (column === "status") {
          return {
            name: "status",
            callback: (value) => formatStatus(value)
          }
        } else  {
          return {
            name: column,
            title: column.replace(/_/g, " ")
          }
        }
      })
      this.fields.push("__slot:actions")
      this.fields.unshift("__checkbox")
      this.initLoad++
    } else {
      this.checkedFields = ["id", "code", "name", "status"];
      this.fields = [
        "__checkbox",
        {name: "id", title: "id"},
        {name: "code", title: "code"},
        {name: "name", title: "name"},
        {
          name: "status",
          callback: (value) => formatStatus(value)
        },
        "__slot:actions"
      ];
      localStorage.removeItem(localStoreName)
    }

    if (this.currentProfile == "users" && (this.checkedFields.includes("code") || this.fields.includes(this.fields.find(el=>el.name == 'code')))) {
      var indexOfField = this.fields.findIndex(object => {
                        return object.name === 'code';
                      });
      this.fields[indexOfField] = {name: "user_name", title: "user name"}
      var indexOfCheckField = this.checkedFields.indexOf("code")
      this.checkedFields[indexOfCheckField] = "user_name"
    }
  },
  mounted: async function() {
    //this.accessRights = ['A', 'W', 'V']
    this.loading = true;
    component_x = this;
    this.accessRights = this.$attrs.accessRights;
    this.apiURL = this.currentApiURL;

    if (this.currentProfile == "sites" || this.currentProfile == "users") {
      this.locationOptions = await HTTPRequest.getRequest(
        this.endPoint + "locations/cascader_view",
        null
      );
    }

    this.loading = false;
  },
};
</script>

<style lang="scss">
.draggable {
  cursor: grab
}

.advanced-profile-delete-modal-danger {
  .ant-modal-header {
    background: #fff1f0;
    border-bottom: 1px solid #ffa39e;
  }

  .ant-modal-title {
    color: #cf1322;
  }
}

.advanced-profile-delete-modal-warning {
  .ant-modal-header {
    background: #fff7e6;
    border-bottom: 1px solid #ffd591;
  }

  .ant-modal-title {
    color: #d48806;
  }
}
</style>
